import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const SdgEducationIcon: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><path d="M10 17V33.58C10 33.58 14 38 24 38C34 38 38 33.58 38 33.58V17" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" /><path d="M2 13L24 2L46 13" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" /><path d="M46 13L24 24L2 13" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" /><path d="M46 14.5V29.5" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default SdgEducationIcon;